import React from 'react'
// libs
import styled from 'styled-components'
import { change } from 'redux-form'
import { useDispatch } from 'react-redux'
// components
import { Collapse } from 'components/Modals/PlanItems/styles'
// view components
import Field from './components/Field'
import FormField from './components/FormField'
// constants
import { Forms } from 'constants/forms'
// types
import { FieldType, IField, IRiskTemplate } from 'types/graphql'
// utils
import orderBy from 'lodash/orderBy'

const TableLabel = styled.span`
  font-size: 16px;
`

const FieldsWrapper = styled.div`
  padding-left: 40px;
`

interface Props {
  field: IField
  fields: IField[]
  parentId: string
  isRelated: boolean
  riskTemplate: IRiskTemplate
}

const FieldsGroup: React.FC<Props> = ({ field, fields, parentId, isRelated, riskTemplate }) => {
  const dispatch = useDispatch()

  const [isExpanded, setExpanded] = React.useState(false)

  React.useEffect(() => {
    if (fields.length) {
      dispatch(
        change(Forms.RISK_VIEW_FORM, `fields.${field.id}`, {
          active: true,
          fieldId: field.id,
          ...(isRelated && { riskTemplateId: riskTemplate.id })
        })
      )
    }
  }, [])

  if (!fields.length) {
    return null
  }

  return (
    <>
      <Collapse isCollapsed={!isExpanded} handleClick={() => setExpanded(!isExpanded)}>
        <TableLabel>{field.label}</TableLabel>
      </Collapse>
      {isExpanded && (
        <FieldsWrapper>
          {fields.map((field) => {
            const isForm = !!riskTemplate.fieldLinks.find(({ field: { id } }) => id === field.id)
            const isTable = field.fieldType === FieldType.Table
            const isSection = field.fieldType === FieldType.Section

            if (isTable || isSection) {
              const subFields = orderBy(
                riskTemplate.fields.filter((item) => item.parentFieldId === field.id),
                'position'
              )

              return (
                <FieldsGroup
                  field={field}
                  key={field.id}
                  fields={subFields}
                  parentId={field.id}
                  isRelated={isRelated}
                  riskTemplate={riskTemplate}
                />
              )
            }

            if (isForm) {
              return (
                <FormField
                  key={field.id}
                  field={field}
                  parentId={parentId}
                  isRelated={isRelated}
                  riskTemplate={riskTemplate}
                />
              )
            }

            return (
              <Field
                field={field}
                key={field.id}
                parentId={parentId}
                isRelated={isRelated}
                riskTemplate={riskTemplate}
              />
            )
          })}
        </FieldsWrapper>
      )}
    </>
  )
}

export default FieldsGroup
